import { render, staticRenderFns } from "./Terezie.vue?vue&type=template&id=1b6a7a74&scoped=true&"
import script from "./Terezie.vue?vue&type=script&lang=js&"
export * from "./Terezie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6a7a74",
  null
  
)

export default component.exports